import API from '@/services/api';

export default {
  namespaced: true,
  state: {
    list: [],
  },
  getters: {
    ['resources:get']: state => state.list,
  },
  mutations: {
    ['resources:set'](state, { data }) {
      if (Array.isArray(data)) {
        const CONTENT_SYMBOL_LIMIT = 366;

        state.list = data.map((resource) => {
          const { content } = resource;

          if (content.length < CONTENT_SYMBOL_LIMIT) {
            return resource;
          }

          return { ...resource, content: `${content.substring(0, CONTENT_SYMBOL_LIMIT)}...` };
        });
      }
    },
  },
  actions: {
    async ['resources:fetch']({ commit }) {
      try {
        const resources = await API.getResources();
        commit('resources:set', resources);
      } catch (err) {
        console.error(err);
      }
    },
    async ['resourceDetails:fetch'](context, id) {
      try {
        return await API.getResourceDetails({ params: { id } });
      } catch (err) {
        console.error(err);
        return {};
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/resource/index.js